<template>
    <b-container fluid>
        <b-row class="d-flex justify-content-end" v-if="isDebug">
            <b-col sm="2">
                <b-form-group class="mb-3">
                    <b-form-select plain v-model="assistantId" :options="asisstantOptions" size="sm">
                        <template v-slot:first>
                            <b-form-select-option :value="null">select assistant</b-form-select-option>
                        </template>
                    </b-form-select>
                </b-form-group>
            </b-col>
        </b-row>
        <b-row>
            <b-col>
                <iq-card body-class="chat-page p-0" class="overflow-hidden">
                    <template v-slot:body>
                        <div class="chat-head">
                            <header class="d-flex justify-content-between align-items-center bg-white p-3">
                                <ToggleButton :mini-toggle="true" :close-button="false"
                                    toggleShow="#chat-user-detail-popup" mediaClass="chat-user-profile">
                                    <template v-slot:media>
                                        <img :src="checkUser()" alt="avatar" class="avatar-50 ">
                                    </template>
                                    <template v-slot:body>
                                        <h5 class="mb-0">Sylvia - sales oriented product expert.</h5>
                                    </template>
                                </ToggleButton>
                            </header>
                        </div>
                        <div class="chat-content scroller" ref="chatContent">
                            <template v-for="(item, index) in chat">
                                <div class="chat chat-left" :key="index" v-if="!item.me">
                                    <div class="chat-user">
                                        <a class="avatar m-0">
                                            <img :src="checkUser()" alt="avatar" class="avatar-50" />
                                        </a>
                                        <span class="chat-time mt-1">{{ item.time }}</span>
                                    </div>
                                    <div class="chat-detail">
                                        <div class="chat-message">
                                            <p v-html="item.text"></p>
                                        </div>
                                    </div>
                                </div>
                                <div class="chat" :key="index" v-else>
                                    <div class="chat-user">
                                        <a class="avatar m-0">
                                            <Avatar :imageUrl="profile.avatar_url"
                                                :backgroundColor="profile.avatar_color" :initials="profile.initials"
                                                :prettyName="profile.prettyName" :small="false" :showTooltip="false" />
                                        </a>
                                        <span class="chat-time mt-1">{{ item.time }}</span>
                                    </div>
                                    <div class="chat-detail">
                                        <div class="chat-message">
                                            <p v-html="item.text"></p>
                                        </div>
                                    </div>
                                </div>
                            </template>
                        </div>
                        <div class="chat-footer p-3 bg-white">
                            <b-row class="mb-2" v-if="error">
                                <b-col>
                                    <b-alert :show="true" variant="alert" class="text-white bg-danger mb-0">
                                        <div class="iq-alert-icon">
                                            <i class="ri-alert-line"></i>
                                        </div>
                                        <div class="iq-alert-text">Failed to generate data (threadId: {{ threadId }}): {{ error }}. Please try
                                            again.</div>
                                    </b-alert>
                                </b-col>
                            </b-row>
                            <form class="d-flex align-items-center" action="javascript:void(0);">
                                <input type="text" class="form-control mr-3" autofocus placeholder="Type your message"
                                    v-model="message">
                                <button type="submit" @click="submitMessage"
                                    class="btn btn-primary d-flex align-items-center p-2" :disabled="loading">
                                    <span class="d-none d-lg-block ml-1" v-if="!loading">Send</span>
                                    <b-spinner label="Spinning" v-if="loading" size="sm"></b-spinner>
                                </button>
                            </form>
                        </div>
                    </template>
                </iq-card>
            </b-col>
        </b-row>
    </b-container>
</template>

<script>
import { Converter } from 'showdown';
import { core } from '../../../config/pluginInit';
import User from '../../../Model/User';
import ChatItem from './ChatItem.vue';
import ToggleButton from './ToggleButton';
import { createThread, defaultAssistantId, Message, sendMessageToThread } from '../../product-expert';
import Avatar from "./Avatar";
import { accessToken, parseJwt } from "../../../Utils/auth";
import { isDebug } from "../../../Utils/account";
import gql from "graphql-tag";
import { getOwnerData, prettyName } from '../../../Utils/getOwnerData';
import { fetchAssistants } from '../../../ai-assistant';

const ROOT_ORGANIZATION = gql`
  query rootOrganization($id: uuid!) {
    organizations_by_pk(id: $id) {
      id
      name
      metadata
    }
  }
`;

const PROFILE = gql`
  query profile($id: uuid!) {
    users_by_pk(id: $id) {
      id
      email
      first_name
      last_name
      role
      avatar_url
      avatar_color
    }
  }
`;

function generateInitials(name, surname, email) {
    let initials = '';

    // Check if name and surname are provided
    if (name && surname) {
        initials = `${name[0]}${surname[0]}`;
    } else if (name) {
        // Only name is provided
        initials = name[0];
    } else if (surname) {
        // Only surname is provided
        initials = surname[0];
    } else if (email) {
        // Fallback to email if name and surname are not available
        initials = email.substring(0, 2);
    } else {
        // In case email is also not provided or is empty
        initials = '?';
    }

    return initials.toUpperCase();
}

export default {
    name: 'Index',
    components: { ChatItem, ToggleButton, Avatar },
    mounted() {
        core.index();
        this.initAssistantOptions();
    },
    data() {
        return {
            user: new User({ id: 1, name: 'Anna Sthesia', role: 'Developer', image: require('../../../assets/images/user/user-08.jpg'), isActive: true }),
            chat: [],
            message: '',
            threadId: '',
            loading: false,
            error: '',
            asisstantOptions: [],
            assistantId: defaultAssistantId,
            isDebug: isDebug()
        }
    },
    apollo: {
        profile: {
            query: PROFILE,
            variables() {
                const { sub } = parseJwt(accessToken());
                return {
                    id: sub
                };
            },
            update: data => {
                return {
                    ...data.users_by_pk,
                    prettyName: prettyName(
                        data.users_by_pk.first_name,
                        data.users_by_pk.last_name,
                        data.users_by_pk.email,
                    ),
                    ...getOwnerData(data.users_by_pk),
                    initials: generateInitials(
                        data.users_by_pk.first_name,
                        data.users_by_pk.last_name,
                        data.users_by_pk.email,
                    ),
                    nOfDefaultOrganizations: data.users_by_pk.organizations_aggregate?.aggregate?.count,
                };
            }
        },
        rootOrganization: {
            query: ROOT_ORGANIZATION,
            variables() {
                const parsedJWT = parseJwt(accessToken());
                const id = parsedJWT['https://hasura.io/jwt/claims']?.['x-hasura-organization-id']
                return { id };
            },
            update: data => {
                return data.organizations_by_pk
            }
        }
    },
    computed: {},
    methods: {
        checkUser() {
            return require('../../../assets/images/user/ai-avatar.png')
        },
        copyText() {
            core.Snackbar({ text: 'Copied' })
        },
        async initChat() {
            this.loading = true;
            const {metadata} = this.rootOrganization;
            const threadId = await createThread(metadata, this.assistantId);
            this.threadId = threadId;
            this.chat.push(new Message({
                id: '',
                text: `Hi, I'm Sylvia - your product expert. How can I help you today?`,
                userId: 5,
                me: false,
                created_at: ''
            }));
            this.loading = false;
        },
        async initAssistantOptions() {
            const assistants = await fetchAssistants();            
            this.asisstantOptions = assistants.map(i => ({
                value: i.id, text: i.name
            }));
            this.assistantId = defaultAssistantId;
        },
        async submitMessage() {
            this.error = '';
            this.loading = true;
            try {
                const msg = this.message;
                this.chat.push(new Message({
                    id: '',
                    text: msg,
                    userId: 5,
                    me: true,
                    created_at: ''
                }))
                this.message = '';

                const response = await sendMessageToThread({
                    message: msg,
                    threadId: this.threadId,
                    organizationId: this.rootOrganization.id,
                    assistantId: this.assistantId
                });
                const converter = new Converter();
                const html = converter.makeHtml(response);
                this.chat.push(new Message({
                    id: '',
                    text: html,
                    userId: 5,
                    me: false,
                    created_at: ''
                }))
            } catch (error) {
                this.error = error.message;
            }
            this.loading = false;

        },
        scrollToBottom() {
            this.$nextTick(() => {
                const chatContent = this.$refs.chatContent;
                chatContent.scrollTop = chatContent.scrollHeight;
            });
        },

    },
    watch: {
        rootOrganization(){
            this.initChat();
        },
        chat() {
            this.scrollToBottom();
        }
    },
}
</script>
<style>
.remove-toggle::after {
    content: unset;
}

.chat-message {
    max-width: 75%;
    text-align: left !important;
    box-shadow: 0 2px 4px 0 rgba(140, 166, 182, 0.5) !important;
}

.chat-message h1,
.chat-message h2,
.chat-message h3,
.chat-message h4,
.chat-message h5,
.chat-message h6 {
    color: white !important;
}

.chat-message h3 {
    font-size: 1.15rem;
}

.chat-head {
    box-shadow: 0px 0px 25px 0px rgba(45, 69, 95, 0.1);
}
</style>